import { render, staticRenderFns } from "./UpdateHandler.vue?vue&type=template&id=3b58ea79"
import script from "./UpdateHandler.vue?vue&type=script&lang=ts"
export * from "./UpdateHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports